/**
 * Default calculators and placeholder helpers
 */

import { getSlottermijnPercentage, getDefaultSlottermijnForType } from '@components/_shared/lease/slottermijn.js';

export { getSlottermijnPercentage, getDefaultSlottermijnForType };

/**
 * Calculate default aanbetaling (down payment) based on aankoopbedrag.
 * Currently €0.
 * @param {number} aankoopbedrag
 * @returns {number}
 */
export function getDefaultAanbetaling( aankoopbedrag ) {
    // Standaardwaarde is nu €0
    return 0;
}

/**
 * Calculate default slottermijn based on leasebedrag.
 * Currently 15%.
 * @param {number} leasebedrag
 * @returns {number}
 */
export function getDefaultSlottermijn( leasebedrag ) {
    const base = Number( leasebedrag || 0 );
    return Math.round( base * 0.15 );
}

/**
 * Calculate default slottermijn for 72 months based on resterend bedrag.
 * Uses percentage based on looptijd (zakelijk only).
 * @param {number} resterendBedrag Remaining financing amount (aankoopbedrag - aanbetaling).
 * @param {number} type Lease type: 0 = Zakelijk. Optional, defaults to 0.
 * @returns {number} Default slottermijn amount.
 */
export function getDefaultSlottermijn72( resterendBedrag, type = 0 ) {
	const base = Number( resterendBedrag || 0 );
	const percentage72 = getSlottermijnPercentage( 72, type );
	return Math.round( base * percentage72 );
}

